import { FC } from 'react';
import { CustomModal } from '@mybonum/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Flex, Typography } from 'antd';

import { TAdminDeleteProps } from './types.ts';

import { useMessage } from '@/hooks/use-message.ts';
import { API } from '@/services/api';

export const AdminDelete: FC<TAdminDeleteProps> = ({ record, open, onClose }) => {
    const queryClient = useQueryClient();
    const { message } = useMessage();

    const { mutateAsync: deleteAdmin, isPending } = useMutation({
        mutationFn: (id: number) => API.ADMINS.deleteAdmin(id),
        onError: async (error) => {
            await message.error(error.message || 'Something went wrong...');
        },
    });

    const handleDelete = async (): Promise<void> => {
        if (!record?.id) return;

        await deleteAdmin(record.id);
        await queryClient.invalidateQueries({ queryKey: API.ADMINS.getAdmins().queryKey });
        onClose();
        message.success(`Admin ${record.email} deleted successfully`);
    };

    return (
        <div>
            <CustomModal
                width={360}
                open={open}
                padding="small"
                onCancel={onClose}
                title="Delete admin"
                destroyOnHidden
                footer={
                    <Flex gap={16} justify="space-between">
                        <Button
                            onClick={() => {
                                onClose();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" danger onClick={handleDelete} loading={isPending}>
                            Delete
                        </Button>
                    </Flex>
                }
            >
                <Typography style={{ color: 'var(--color-brand-info)', textAlign: 'center' }}>
                    Are you sure you want to delete this admin?
                </Typography>
            </CustomModal>
        </div>
    );
};
